import styled from '@emotion/styled'

import { breakpoint, calcRem } from 'component-library/__styling/style-functions'
import { colors, metrics } from 'component-library/__styling/settings'

import { FigCaption } from 'component-library/publication/FigCaption/FigCaption'
import { themedValue } from 'component-library/__styling/themed-value'

export interface StyledArticleVideoProps {
    isHeroVideo?: boolean
}

const pnMarginSml = metrics.perthnow.margins.sm
const pnMarginMd = metrics.perthnow.margins.md
const pnMarginLrg = metrics.perthnow.margins.lg

export const StyledArticleVideo = styled('figure')<StyledArticleVideoProps>(
    {
        flexGrow: 1,
        marginTop: 0,
        clear: 'both',
    },
    ({ theme, isHeroVideo }) => ({
        marginTop: themedValue(theme, {
            perthnow: isHeroVideo ? 0 : calcRem(pnMarginLrg),
            fallback: undefined,
        }),
        marginBottom: themedValue(theme, {
            perthnow: isHeroVideo ? 0 : calcRem(pnMarginLrg),
            thewest: isHeroVideo ? undefined : calcRem(metrics.thewest.margins.md),
            sevennews: isHeroVideo ? undefined : calcRem(metrics.sevennews.margins.lg),
        }),
        marginLeft: themedValue(theme, { perthnow: calcRem(-pnMarginMd), fallback: 'auto' }),
        marginRight: themedValue(theme, { perthnow: calcRem(-pnMarginMd), fallback: 'auto' }),
        width: themedValue(theme, {
            sevennews: '100%',
            fallback: undefined,
        }),
        [breakpoint('md')]: {
            marginLeft: themedValue(theme, { perthnow: 'auto', fallback: 0 }),
            marginRight: themedValue(theme, { perthnow: 'auto', fallback: 0 }),
        },
    })
)

export const StyledArticleVideoContainer = styled('div')<StyledArticleVideoProps>(
    ({ theme, isHeroVideo }) => ({
        marginBottom: themedValue(theme, {
            thewest: calcRem(10),
            perthnow: isHeroVideo ? 0 : calcRem(pnMarginSml),
            sevennews: calcRem(metrics.sevennews.margins.sm),
        }),
    })
)

// Figcaption for Article Video's
export const StyledFigcaption = styled(FigCaption)<StyledArticleVideoProps>(
    ({ theme, isHeroVideo }) => ({
        backgroundColor: themedValue(theme, {
            perthnow: isHeroVideo ? colors.black : undefined,
            fallback: undefined,
        }),
        padding: themedValue(theme, {
            thewest: calcRem(0, 0, metrics.thewest.margins.sm),
            perthnow: isHeroVideo
                ? `${calcRem(pnMarginSml)}`
                : `${calcRem(0, pnMarginSml, pnMarginSml)}`,
            sevennews: calcRem(0, 0, metrics.sevennews.margins.sm),
        }),
        borderBottom: themedValue(theme, {
            thewest: `2px solid ${colors.thewest.greySeal}`,
            perthnow: isHeroVideo ? undefined : `2px solid ${colors.perthnow.greyPyrite}`,
            sevennews: `1px solid ${colors.sevennews.alto}`,
        }),

        [breakpoint('xs')]: {
            padding: themedValue(theme, {
                perthnow: isHeroVideo
                    ? `${calcRem(pnMarginSml)} ${calcRem(pnMarginLrg)}`
                    : undefined,
                fallback: undefined,
            }),
        },
    })
)
